/* eslint-env jquery  */

/**
 *
 * NB: This file does NOT use JQUERY - but ki.js and
 * ki.extend.js which look a lot like jquery.
 *
 * Also there are some utility methods that are used
 * that are found in the utils.js file.
 *
 * They are:
 *  - loadScript(url, callback)
 *  - scrollToTy(scrollTarget, speed, easingFunction)
 *  - closest(el, selector)
 *
 * Also the ki.extend.local.js file contains some extra
 * ki methods for parent(), parents(), find(), offsetTop() and height()
 *
 */

const ENV = ','
const buildNumber = '2337.1.0'

function isIE11 () {
  if (
    navigator.userAgent.indexOf('MSIE') !== -1 ||
    navigator.appVersion.indexOf('Trident/') > 0
  ) {
    return true
  }
  return false
}

if (isIE11()) {
  // source:  http://alistapart.com/article/crossbrowserscripting
  if (!document.ELEMENT_NODE) {
    document.ELEMENT_NODE = 1
    document.ATTRIBUTE_NODE = 2
    document.TEXT_NODE = 3
    document.CDATA_SECTION_NODE = 4
    document.ENTITY_REFERENCE_NODE = 5
    document.ENTITY_NODE = 6
    document.PROCESSING_INSTRUCTION_NODE = 7
    document.COMMENT_NODE = 8
    document.DOCUMENT_NODE = 9
    document.DOCUMENT_TYPE_NODE = 10
    document.DOCUMENT_FRAGMENT_NODE = 11
    document.NOTATION_NODE = 12
  }

  document._importNode = function (node, allChildren) {
    switch (node.nodeType) {
      case document.ELEMENT_NODE:
        var newNode = document.createElement(node.nodeName)
        /* does the node have any attributes to add? */
        var il, i
        if (node.attributes && node.attributes.length > 0) {
          for (i = 0; (il = node.attributes.length); i < il) {
            newNode.setAttribute(
              node.attributes[i].nodeName,
              node.getAttribute(node.attributes[i++].nodeName)
            )
          }
        }
        /* are we going after children too, and doesthe node have any? */
        if (allChildren && node.childNodes && node.childNodes.length > 0) {
          for (i = 0; (il = node.childNodes.length); i < il) {
            newNode.appendChild(
              document._importNode(node.childNodes[i++], allChildren)
            )
          }
        }
        return newNode

      case document.TEXT_NODE:
      case document.CDATA_SECTION_NODE:
      case document.COMMENT_NODE:
        return document.createTextNode(node.nodeValue)
    }
  }
}

function getCourseBtn (courseId, semesterId) {
  return document.querySelector('#btn-course-' + courseId + '-' + semesterId)
}

function onCoursesUpdated (newState) {
  const coursesSelected = newState.getCourseOrderLines()

  const selectedButtons = document.querySelectorAll('.added-btn')

  selectedButtons.forEach(function (elm) {
    elm.classList.remove('added-btn')
  })

  coursesSelected.forEach((orderLine) => {
    const sku = orderLine.product.sku
    const courseId = orderLine.course.id

    for (const semester of orderLine.semesters) {
      const courseBtn = getCourseBtn(courseId, semester.id)
      if (!courseBtn) {
        console.warn('Could not find button for course', courseId, semester.id)
        return
      }
      courseBtn.classList.add('added-btn')
    }
  })
}

function courseUnChosen (courseId, sku) {
  window.orderStore.removeSemester(courseId, sku)
}

function courseChosen (id, productSku) {
  console.log('Select course', id, productSku)
  window.orderStore.selectSemester(id, productSku)
}

function addPackage (event) {
  try {
    event.stopPropagation()
    const btn = this

    if (btn.classList.contains('FagPakke-btn-added')) {
      window.checkout.togglePopup()
      return
    }

    const courses = JSON.parse(this.dataset.courses)

    window.checkout.setPackageCode(this.dataset.packagecode)
    window.orderStore.selectCourses(courses)

    if (window.orderStore && window.orderStore.orderState && Array.isArray(window.orderStore.orderState.orderLines)) {
      window.orderStore.orderState.orderLines.forEach(orderLine => {
        window.orderStore.postEcommerceEvent('add_to_cart', orderLine)
      })
    }

    window.checkout.setMeta({ packageCourses: courses })
    if (btn.classList.contains('fagpakke-info__button')) {
      btn.classList.add('fagpakke-info__btn-selected')
      return
    }
    return
  } catch (e) {
    console.error('Error in addPackage: ', e, e.message)
  }
}

function registerListeners (orderStore) {
  // course page
  if (
    document.querySelector('.pricing-container') ||
    document.querySelector('.course-buy-button') ||
    document.querySelector('.course-pricing__modal')
  ) {
    orderStore.subscribe(onCoursesUpdated)
  }
  // window.checkout.on('state', function (param) { })

  // IntroText pageparts.
  // todo remove
  if (document.querySelector('.IntroText')) {
    if (window.location.hash.indexOf('introtext') > -1) {
      document.querySelector(window.location.hash).classList.add('active')
    }
    const links = document.querySelectorAll('.IntroText')
    for (let i = 0; i < links.length; i++) {
      const elm = links[i]
      elm.addEventListener('click', function (event) {
        if (event.target.tagName === 'A') {
          event.currentTarget.classList.toggle('active')
        }
      })
    }
  }
}

const players = {}

function showMovie (elementId, movieId, aspectRatio) {
  if (typeof jwplayer === 'undefined') {
    console.error('showMovie called without jwplayer defined!')
  }
  players[elementId] = jwplayer(elementId).setup({
    aspectratio: aspectRatio,
    playlist: '//content.jwplatform.com/feeds/' + movieId + '.json'
  })
}

function showMovieWithLoad (elementId, movieId, aspectRatio) {
  if (typeof jwplayer === 'undefined') {
    loadScript(
      'https://cdn.jwplayer.com/libraries/u2lebR3p.js',
      showMovie.bind(null, elementId, movieId, aspectRatio)
    )
  } else {
    showMovie(elementId, movieId, aspectRatio)
  }
}

function stopMovie (elementId) {
  const id = elementId
  if (players[id]) {
    players[id].remove()
    players[id] = null
  }
}

function onMovieTriggered (event) {
  const movieElement = document.querySelector(event.curretTarget.href)
  showMovieWithLoad(
    movieElement.id,
    movieElement.datalist.jwid,
    movieElement.datalist.aspect
  )
}

/* Open video modal and load video (if necessary) */
document.querySelectorAll('.popvideo').forEach((item) => {
  item.addEventListener('click', (event) => {
    try {
      event.preventDefault()
      const modal = document.getElementById(event.currentTarget.dataset.modal)
      modal.classList.add('active')
      const video = modal.querySelector('.movie-element')
      if (video) {
        const videoId = video.dataset.jwid
        const videoAspect = video.dataset.aspect
        const videoRandomId = modal.getAttribute('data-random-id')
        const videoElement = 'movie-' + videoId + '-' + videoRandomId
        showMovieWithLoad(videoElement, videoId, videoAspect)
      }
    } catch (e) {
      console.error('Error opening modal: ', e, e.message, event)
    }
  })
})

/* Load inline movie */
document.querySelectorAll('.inline-movie').forEach((item) => {
  const videoId = item.dataset.jwid
  const videoAspect = item.dataset.aspect
  const videoElement = item.getAttribute('id')
  showMovieWithLoad(videoElement, videoId, videoAspect)
})

/* Close video modal and stop/remove video */
document.querySelectorAll('.closemodal').forEach((item) => {
  item.addEventListener('click', (event) => {
    event.preventDefault()
    const modal = document.getElementById(event.currentTarget.dataset.modal)
    modal.classList.remove('active')
    modal.style.display = 'none'
    document.querySelector('html').style.overflow = 'visible'
    try {
      const videoId = modal.dataset.jwid
      if (videoId) {
        const videoRandomId = modal.getAttribute('data-random-id')
        stopMovie('movie-' + videoId + '-' + videoRandomId)
      }
    } catch (e) {
      console.error('Error closing modal via button:', e, e.message, e.stack)
    }
  })
})

/* Close and remove on click outside */
window.addEventListener('click', function (event) {
  if (event.target.classList.contains('popup')) {
    const toggles = document.querySelectorAll('.toggle')
    const modal = event.target
    modal.style.display = 'none'
    modal.classList.remove('active')
    modal.classList.remove('active2')
    // console.log('remove modal click outside popup', modal)
    document.querySelector('html').style.overflow = 'visible'
    try {
      const videoRandomId = modal.getAttribute('data-random-id')
      const videoId = modal.getAttribute('data-jwid')
      if (videoId && videoRandomId) {
        stopMovie('movie-' + videoId + '-' + videoRandomId)
      }
    } catch (e) {
      console.error(
        'Error stopping movie while closing modal: ',
        e,
        e.message,
        event.target.dataset
      )
    }

    for (let i = 0; i < toggles.length; i++) {
      toggles[i].classList.remove('active')
    }
  }
})

window.onload = function () {
  /* Modals */
  const modalBtns = Array.from(document.querySelectorAll('.modalbtn'))
  const toggles = document.querySelectorAll('.toggle')

  modalBtns.forEach((btn) => {
    btn.onclick = function () {
      const modal = document.getElementById(btn.getAttribute('data-modal'))
      const video = modal.querySelector('.movie-element')
      if (video) {
        const videoId = video.getAttribute('data-jwid')
        const videoRandomId = modal.getAttribute('data-random-id')
        const videoAspect = video.getAttribute('data-aspect')
        const videoElement = 'movie-' + videoId + '-' + videoRandomId
        showMovieWithLoad(videoElement, videoId, videoAspect)
      } else if (modal.querySelector('.movie-element-video')) {
        showMovieBasedOnFormat(modal.querySelector('.movie-element-video'))
      }

      /* Open modal */
      modal.style.display = 'flex'
      modal.classList.add('active')
      document.querySelector('html').style.overflow = 'hidden'

      if (false && modal.querySelector('video')) {
        setTimeout(() => {
          modal
            .querySelector('video')
            .play()
            .catch((e) => {
              console.error('Error starting video:', e, e.message)
            })
        }, 100)
      }
    }
  })
}

/**
 * Popups effect
 */
function Popups () {
  const body = document.body
  const buttons = document.querySelectorAll('.toggle')

  buttons.forEach(function (currentBtn) {
    currentBtn.addEventListener('click', function () {
      const linkto = currentBtn.getAttribute('data-modal')
      const popupel = document.getElementById(linkto)
      if (currentBtn.classList.contains('toggle-close')) {
        popupel.classList.remove('active2')
        setTimeout(function () {
          for (let i = 0; i < buttons.length; i++) {
            buttons[i].classList.remove('active')
          }
        }, 200)
      } else {
        currentBtn.classList.add('active')
        setTimeout(function () {
          popupel.classList.add('active2')
        }, 100)
      }
    })
  })
}

document.addEventListener('DOMContentLoaded', function () {
  Popups()
})

// called on startup.
function showMovieElements () {
  let i
  const movieElements = document.querySelectorAll('[data-movie-id]')
  for (i = 0; i < movieElements.length; i++) {
    const element = movieElements.item(i)
    showMovieWithLoad(element.id, element.dataset.jwid, element.dataset.aspect)
  }

  const popupTriggers = document.querySelectorAll('.popup-video-trigger')
  for (i = 0; i < popupTriggers.length; i++) {
    const popupTrigger = popupTriggers.item(i)
    popupTrigger.addEventListener('click', onMovieTriggered)
  }
}

function sortFagListe () {
  const fagListeDiv = document.querySelector('[data-course-listing]')
  if (!fagListeDiv) {
    return
  }

  const courseItems = fagListeDiv.querySelectorAll('[data-courseline]')

  if (!courseItems) {
    return
  }

  for (const item of courseItems) {
    const hasSelectedCourse = item.querySelector('.added-btn')
    if (hasSelectedCourse) {
      // move item to top of list
      fagListeDiv.insertBefore(item, fagListeDiv.firstChild)
    }
  }
}

function onSiteLoad () {
  // add a course
  $('.course-btn').on('click', function (event) {
    const isActive = this.className.indexOf('added-btn') > -1
    const courseid = this.dataset.courseid
    const productSku = this.dataset.product
    if (isActive) {
      courseUnChosen(courseid, productSku)
      return false
    }

    courseChosen(courseid, productSku)
    return false
  })

  /**
   * Load prototypes if needed
   */

  if (!window.fetch || !window.Promise) {
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.msMatchesSelector
    }
    if (!Element.prototype.closest) {
      Element.prototype.closest = function (s) {
        let el = this

        do {
          if (el.matches(s)) return el
          el = el.parentElement || el.parentNode
        } while (el !== null && el.nodeType === 1)
        return null
      }
    }
    loadScript('/js/promise.min.js?bn=' + buildNumber)
    loadScript('/js/fetch.umd.min.js?bn=' + buildNumber)
    loadScript('/js/classlist.min.js?bn=' + buildNumber)
    loadScript(
      '/js/intersection-observer.min.js?bn=' + buildNumber,
      function () {
        if (window.__IE11_awaitLoaded) {
          for (let i = window.__IE11_awaitLoaded.length - 1; i >= 0; i--) {
            window.__IE11_awaitLoaded[i]()
          }
        }
      }
    )
  }

  function startApp () {
    window.startCheckout()
    registerListeners(window.orderStore)
    window.orderStore.emit()

    // must load after we have loaded fetch()
    if (window.loadVeiledningsForm) {
      window.loadVeiledningsForm()
    }
    showMovieElements()
    sortFagListe()
  }

  if (ENV === 'dev') {
    loadScript('/js/checkout.js?' + window.buildNumber + Date.now(), startApp)
  } else {
    loadScript('/js/checkout.min.js?' + buildNumber, startApp)
  }

  if (document.querySelector('.pricing-sidebar')) {
    // new StickyJs('.pricing-sidebar')
  }

  if (document.querySelectorAll('.course-pkg-select-btn').length) {
    // kurspakker__btn:
    document
      .querySelectorAll('.course-pkg-select-btn')
      .forEach((btn) => btn.addEventListener('click', addPackage))
  }
}

// https://stackoverflow.com/questions/799981/document-ready-equivalent-without-jquery
function ready (callback) {
  // in case the document is already rendered
  if (document.readyState != 'loading') callback()
  // modern browsers
  else if (document.addEventListener) { document.addEventListener('DOMContentLoaded', callback) }
}

ready(onSiteLoad)

// ÅPNE OG LUKKE HOVEDMENY PÅ MOBIL
var headerMenuButton = document.querySelector('.site-header__menu-btn')
var siteMenu = document.querySelector('.site-header__nav-wrap')

headerMenuButton.addEventListener('click', (e) => {
  headerMenuButton.classList.toggle('close')
  siteMenu.classList.toggle('open')
})

// ÅPNE OG LUKKE UNDERMENY PÅ MOBIL OG DESKTOP
var siteMenuDropdownButtons = document.querySelectorAll(
  '.site-header__nav__list__item__btn'
)

siteMenuDropdownButtons.forEach((button) => {
  button.addEventListener('click', (e) => {
    button.classList.toggle('close')
    button.nextElementSibling.classList.toggle('open')
  })
})

// SKJULE HEADER VED SCROLL NED OG VISE VED SCROLL OPP
var prevScrollpos = window.scrollY
const coursesTableHeader = document.getElementsByClassName(
  'pricing-courses__table-header'
)[0]
const pricingSidebar = document.getElementsByClassName('pricing-sidebar')[0]
window.onscroll = function () {
  var currentScrollPos = window.scrollY

  if (prevScrollpos > currentScrollPos || prevScrollpos < 200) {
    document.getElementById('siteHeader').style.top = '0'
    if (coursesTableHeader) {
      coursesTableHeader.style.top = '108px'
    }
    if (pricingSidebar) {
      pricingSidebar.style.top = '142px'
    }
  } else {
    document.getElementById('siteHeader').style.top = '-110px'
    if (coursesTableHeader) {
      coursesTableHeader.style.top = '0'
    }
    if (pricingSidebar) {
      pricingSidebar.style.top = '32px'
    }
  }

  prevScrollpos = currentScrollPos
  if (prevScrollpos > 0) {
    document.getElementById('siteHeader').classList.add('shadow')
  } else {
    document.getElementById('siteHeader').classList.remove('shadow')
  }
}